import { useDraggable } from '@dnd-kit/core';

export const DraggableItem = ({ id, children }: { id: string; children: React.ReactNode }) => {
    const { attributes, listeners, setNodeRef, isDragging } = useDraggable({ id });

    return (
        <div
            ref={setNodeRef}
            {...attributes}
            {...listeners}
            className={`basic-elements__item ${isDragging ? 'dragging' : ''}`}
            style={{
                cursor: 'grab',
                opacity: isDragging ? 0.45 : 1,
                transition: 'opacity 0.15s ease'
            }}
        >
            {children}
        </div>
    );
};
